import { type ForwardedRef, forwardRef } from 'react'
import type { NumericFormatProps } from 'react-number-format'
import { NumericFormat } from 'react-number-format'

import type { InputProps } from '@/_components/ui/input'
import { Input } from '@/_components/ui/input'

export const CurrencyInput = forwardRef(
  (props: NumericFormatProps<InputProps>, ref: ForwardedRef<HTMLInputElement>) => {
    return (
      <NumericFormat
        {...props}
        thousandSeparator="."
        decimalSeparator=","
        prefix="R$ "
        allowNegative={false}
        customInput={Input}
        getInputRef={ref}
      />
    )
  },
)

CurrencyInput.displayName = 'CurrencyInput'
